/**
 * Tournament message enum.
 */
export enum TournamentMessageEnum {
  OK,
  PRIVATE,
  INSUFFIENT_CREDIT,
  FULL,
  ALREADY_STARTED,
  ALREADY_JOINED,
  NOT_REGISTERED,
  UNKNOWN,
  MOVED,
  WAIT,
  LOST_GAME,
  WON_GAME,
  WINNER,
  FINISHED,
}
